import { type FavoriteData, OfficeFavoriteDataParams, Optional } from 'chaika-frontend-types/frontend-cms';

import { SimpleList } from '@store/models/SimpleList';

export class OfficeFavoriteList extends SimpleList<FavoriteData<OfficeFavoriteDataParams>> {
    public static Name = 'officeFavoriteList' as const;

    public getRecentOfficeId(): Optional<string> {
        const officeData = this.values[0]?.data;

        return officeData?.officeId;
    }
}
